module.exports = '4.6.1';



// WEBPACK FOOTER //
// ./src/version.js